var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 13.2539C3.84171 13.4492 4.15829 13.4492 4.35355 13.2539L7.53553 10.072C7.7308 9.8767 7.7308 9.56012 7.53553 9.36486C7.34027 9.16959 7.02369 9.16959 6.82843 9.36486L4 12.1933L1.17157 9.36486C0.976311 9.16959 0.659728 9.16959 0.464466 9.36486C0.269204 9.56012 0.269204 9.8767 0.464466 10.072L3.64645 13.2539ZM3.5 0.900391L3.5 12.9004H4.5L4.5 0.900391H3.5Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ab1be9e6bf11486697262eff00804a7e.svg";
export { ForwardRef as ReactComponent };